import React, { Component } from 'react';
import {localization} from '../Frames/localization'
import {ColorLinearProgress} from '../../src/App'
import cities from '../Frames/koatuu'
import TextField from '@material-ui/core/TextField';
import { hasActivateCard } from '../Frames/hasActivateCard'


import ButtonRule from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


import {materialThemeField, themeColorText, themeColorLink ,ThemeCheckbox} from '../../src/App'
import { ThemeProvider } from "@material-ui/styles";

import {messageWindow} from '../Elements/Snackbar/MessageWindow'
import MessageWindow from '../Elements/Snackbar/MessageWindow'

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import InputText from '../Elements/TextField/InputText';
import InputTextComplete from '../Elements/TextField/InputTextComplete';
import Grid from '@material-ui/core/Grid';
import Label from '../Elements/Label/labels';
import InputPhoneNumber from '../Elements/TextField/InputPhoneNumber';
import {DatePicker, DatePickerMinMax} from '../Elements/Pickers/DatePickerClientInfo';
import Checkbox from '../Elements/Checkbox/checkboxs';
import Button from "../Elements/Button/buttons";
import Select from '../Elements/Select/selectProfileField'

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

//settings
import {AppliedSettings} from '../../src/App' 

import './clientinfo.css'
import './clientinfoAdaptive.css'

const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")
}
function LabelField(item)
{
    switch(item.id)
    {
        case 1001: return localization.GetTranslate('Profile.Legalname');
        case 1002: return localization.GetTranslate('Profile.CodeEGRPOU');
        case 1003: return localization.GetTranslate('Profile.INN'); 
        case 1004: return localization.GetTranslate('Profile.Certificatenumber');
        case 1005: return localization.GetTranslate('Profile.Gender');
        case 1006: return localization.GetTranslate('Profile.Date of birth');
        case 1007: return localization.GetTranslate('Profile.Address'); 
        case 1008: return localization.GetTranslate('Profile.Phone');
        case 1009: return localization.GetTranslate('Profile.Email');
        case 1010: return localization.GetTranslate('Profile.Second name');
        case 1011: return localization.GetTranslate('Profile.First name');
        case 1012: return localization.GetTranslate('Profile.Thirt name');
        case 1013: return localization.GetTranslate('Profile.Subscription');
        case 1014: return localization.GetTranslate('Profile.CategotyCar');
        case 1015: return localization.GetTranslate('Profile.MarkCar');
        case 1016: return localization.GetTranslate('Profile.Enginevolume');
        case 1017: return localization.GetTranslate('Profile.Consumption');
        case 1018: return localization.GetTranslate('Profile.ManufacturerGBO');
        case 1019: return localization.GetTranslate('Profile.Note');
        case 1020: return localization.GetTranslate('Profile.NumberCar');
        case 1021: return localization.GetTranslate('Profile.City');
        case 1022: return localization.GetTranslate('Profile.Name'); 
        default: return item.name;
    }
}



class ClientInfo extends Component {
    constructor(props)
    {
        super(props)
        this.state = {
            TabNotAvailable: false,
            asyncDisabled: false,
            progress: false,

            open: false,
            openActivate: false,
            FieldActivate: "",
            key: undefined,
            profile: Array,
            idField: [], 
            isLoaded: false,

            hasActivatedCard: false,

            rules: false,
            yearsold: false,
            minYear: 0,
            maxYear: 0,
        }
        this.validateField = this.validateField.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.onSubsmitActivate = this.onSubsmitActivate.bind(this)
        this.resendActivationCode = this.resendActivationCode.bind(this)
        this.ChangeCheckBoxRules = this.ChangeCheckBoxRules.bind(this)
        this.ChangeCheckBoxYearsOld = this.ChangeCheckBoxYearsOld.bind(this)

        this.handleClickOpenActivate = this.handleClickOpenActivate.bind(this)
        this.handleClickOpen = this.handleClickOpen.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleCloseActivate = this.handleCloseActivate.bind(this)
        this.handleAgree = this.handleAgree.bind(this)
        this.handleCancel = this.handleCancel.bind(this)

        this.onChangeActivate = this.onChangeActivate.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeCity = this.handleChangeCity.bind(this)
        this.handleChangePhone = this.handleChangePhone.bind(this)
        this.handleChangeData = this.handleChangeData.bind(this)
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this)
        this.handleChangeSelect = this.handleChangeSelect.bind(this)
        this.SetValueField = this.SetValueField.bind(this)
        this.SetValueFieldCity = this.SetValueFieldCity.bind(this)
    }
    handleClickOpen()
    {
        this.setState({open: true})
    }
    handleClose()
    {
        this.setState({open: false})
    }
    handleClickOpenActivate()
    {
        this.setState({openActivate: true})
    }
    onChangeActivate(event) {
        this.setState({FieldActivate: event.target.value});
      }
    handleCloseActivate()
    {
        this.setState({openActivate: false})
    }
    onSubsmitActivate(event)
    {
        var data = {
            code: this.state.FieldActivate
        }
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        fetch(`/requestCardActivation`, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
            if(response.data != null){
                messageWindow.OpenMessage("success", localization.GetTranslate(response.data))
                this.setState({key: Math.random(),openActivate: false})
                this.props.closefixedMessage()
            }
            else if(response.error != null)
            {
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({key: Math.random()})
            }
        })
        event.preventDefault();
    }
    resendActivationCode(event)
    {
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({})
        }
        fetch(`/resendActivationCode`, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
                if(response.data != null){
                    messageWindow.OpenMessage("info", localization.GetTranslate(response.data))
                    this.setState({key: Math.random()})
                }
                else if(response.error != null)
                {
                    messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                    this.setState({key: Math.random()})
                }
        })
        event.preventDefault();
        
    }
    onSubmit(event)
    {
        this.setState({asyncDisabled: true, progress: true})
        var form = document.getElementById('FormProfile');
        var fields = form.getElementsByTagName("input")
        for(var j=0; j<fields.length; j++)
        {
            if (fields[j].getAttribute("aria-invalid") == "true")
            {
                messageWindow.OpenMessage("warning", localization.GetTranslate('Profile.Invalid Field'))
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
                event.preventDefault();
                return;
            }
            if(fields[j].name == 'requiredField')
            {
                if(fields[j].value.length < 1)
                {
                    messageWindow.OpenMessage("warning", localization.GetTranslate('Profile.Invalid Field'))
                    this.setState({asyncDisabled: false, progress: false, key: Math.random()})
                    event.preventDefault();
                    return;
                }
            }
        }
        var data = {
            fields: {}
        };
        this.state.idField.map(item => {
            if(this.StringIsData(this.state[item]))
            {
                data.fields[item] = this.state[item]._d.getTime();
            }else{
                
                data.fields[item] = this.state[item];
            }
        })
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        fetch(`/alterClientInfo`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.error)
            {
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
            }else if(response.data)
            {
                messageWindow.OpenMessage("success", localization.GetTranslate(response.data))
                this.setState({asyncDisabled: false, progress: false, key: Math.random()})
                this.props.updateUserName()
                if(AppliedSettings.clientInfo_activateCardOnProfileUpdateFromCustomerProfile == 2 && this.state.hasActivatedCard == true)
                {
                    this.handleClickOpenActivate()
                }else if(this.state.hasActivatedCard == true & String(response.data).indexOf("Карта активирована" >= 0))
                {
                   this.props.closefixedMessage()
                }
            }           
        })
        
        event.preventDefault();
    }
    StringIsData(string)
    {       try
            {
                string._d.getTime();
                return true;
            }catch
            {
                return false;
            }
    }
    ChangeCheckBoxRules(value)
    {
        this.setState({rules: value})
    }
    ChangeCheckBoxYearsOld(value)
    {
        this.setState({yearsold: value})
    }
    handleAgree()
    {
        this.setState({rules: true,key: Math.random()})
        this.handleClose()
    }
    handleCancel()
    {
        this.setState({rules: false,key: Math.random()})
        this.handleClose()
    }
    componentDidMount()
    {
        this.props.setSelectedIndex(4)
        hasActivateCard.requestCheckActivateCard(requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
                this.setState({ hasActivatedCard: response.data})
        })

        fetch(`/api/getclientinfo`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.data == null){
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({key: Math.random(),open: true})
            }
            else
            {
                this.setState({
                    profile: response, 
                    isLoaded: true,
                });
                response.data.preset.fields.map(item =>
                    {

                            this.setState({
                                [item.field.id]: response.data.res.clientInfo[item.field.id],
                            })

                        this.state.idField.push(item.field.id)
                    })  
                    this.setState({
                        minYear: response.data.minYear,
                        maxYear: response.data.maxYear,
                    })
            }             
        }).catch((error) => {
            // Handle the error
            this.setState({TabNotAvailable: true})
          })
        this.forceUpdate();
    }
    //VALIDATE
    validateField(value, required) 
    {   
            if(required)
            {
                if(value == "" || value == null || value == undefined)
                {
                    return true;
                }
            }
            else
            {
                return false;
            }
    }
    validateFieldPhoneNumber(value, required) 
    {  
       var phone = String(value);
       phone = phone.replace(/[^0-9]/g, '');
       if(required){
            if(phone.length < 12)
            {
                return true;
            }
            else
            {
                return false;
            }
        }else
        {
            if(phone.length == 0)
            {
                return false;
            }
            else if(phone.length < 12)
            {
                return true;
            }
        }
      }
      validateFieldDate(value, required) 
        {  
            if(required)
            {
                try
                {
                    if(value._isValid == false)
                    {
                        return true;
                    }
                }
                catch
                {
                    if(value == "" || value == null || value == 0)
                    {
                        return true;
                    }
                }          
            }else
            {
                try
                {
                    if(value._isValid == false)
                    {
                        return true;
                    }
                }
                catch
                {
                
                        return false;
               
                }      
            }
      }
      validateFieldDateBirth(value, required, min, max) 
        {  
            var s = min*365+(min/4);
            var e = max*365+(max/4);
            var _start = new Date();
            var _end = new Date();
            _start.setDate(_start.getDate() - e).valueOf();
            _end.setDate(_end.getDate() - s).valueOf()
            if(value < _start || value > _end)
            {
                return true
            }
            if(required)
            {
                try
                {
                    if(value._isValid == false)
                    {
                        return true;
                    }
                }
                catch
                {
                    if(value == "" || value == null || value == 0)
                    {
                        return true;
                    }
                }          
            }else
            {
                try
                {
                    if(value._isValid == false)
                    {
                        return true;
                    }
                }
                catch
                {
                
                        return false;
               
                }      
            }
      }

    //DISABLED PROPS
    EnabledDisabledInputText(alterableFromProfile,value)
    {
        if(value == "" | value == null | value == undefined)
        {
            return null;
        }else
        {
            if(alterableFromProfile == false)
            {
                return "disabled"
            }else{
                return null;
            }
        }
        //{item.alterableFromProfile == false  ? "disabled":null}
    }
    EnabledDisabledDate(alterableFromProfile,value)
    {
        if(value == null)
        {
            return null;
        }else
        {
            if(alterableFromProfile == false)
            {
                return "disabled"
            }else{
                return null;
            }
        }
        //{item.alterableFromProfile == false  ? "disabled":null}
    }
    EnabledDisabledCheckbox(alterableFromProfile,value)
    {
        if(value == "false")
        {
            return null;
        }else
        {
            if(alterableFromProfile == false)
            {
                return "disabled"
            }else{
                return null;
            }
        }
    }

    //LABEL PROPS
    LabelDisabled(alterableFromProfile,value)
    {
        if(value == "" | value == null | value == undefined)
        {
            return "";
        }else
        {
            if(alterableFromProfile == false)
            {
                return localization.GetTranslate('Profile.Edit')
            }else{
                return "";
            }
        }
    }
    LabelDisabledDate(alterableFromProfile,value)
    {
        if(value == null)
        {
            return "";
        }else
        {
            if(alterableFromProfile == false)
            {
                return localization.GetTranslate('Profile.Edit')
            }else{
                return "";
            }
        }
    }
    LabelDisabledCheckbox(alterableFromProfile,value)
    {
        if(value == "false")
        {
            return "";
        }else
        {
            if(alterableFromProfile == false)
            {
                return localization.GetTranslate('Profile.Edit')
            }else{
                return "";
            }
        }
    }


    //VALUE
    SetValueField(id){
        return this.state[id] 
    } 
    SetValueFieldCity(id){
        if(this.state[id] == null | this.state[id] == undefined | this.state[id] == "")
        {
            return ""; 
        }else
        {
            return this.state[id];
        }
    }
    SetValueData(id){
        if(this.state[id])
        {
            return this.state[id] 
        }else
        {
            return null;
        }
    } 
    SetValueFieldCheck(id){
        if(this.state[id] === "true")
        {
            return Boolean(true);
        }else if(this.state[id] === "false")
        {
            return Boolean(false);
        }
    }     
    
    

    //CHANGE
    handleChange = (event) => {
        const { target: { name, value } } = event
        this.setState({ [name]: value },
            () => { this.validateField(name, value) })
      }
    handleChangeCity = (values,name) => {
        this.setState({ [name]: values },
            () => { this.validateField(name, values) })
        
    }
    handleChangePhone = (event) => {
        const { target: { name, value } } = event
        this.setState({ [name]: value.replace(/[^0-9,^+]/g, '')},
            () => { this.validateField(name, value) })
      }
    handleChangeData(date,id){
        this.setState({ [id]: date })

      }
    handleChangeSelect(value,id){
        this.setState({ [id]: value })
      }
    handleChangeCheckbox = (event) => {
        const { target: { name, checked }} = event
        if(checked == true)
        {
            this.setState({ [name]: "true"  })
        }else if(checked == false)
        {
            this.setState({ [name]: "false"  })
        }
      }


    agreeLicense(agree)
    {
        if(agree)
        {
            if(this.state.rules && this.state.yearsold)
            {
                return false;
            }else{
                return true;
            }
        }else{
            return false;
        }
    }
    TypeField(item)
    {   
    var Field = null;
    const profile = this.state.profile;
    switch(item.field.type)
    {
        case 0:
            {
                if(item.field.id != 1008)
                {
                    Field = <InputText
                    error={this.validateField(this.SetValueField(item.field.id),item.required)}
                    id={item.field.id}
                    name={item.field.id}
                    label={LabelField(item.field) +" "+ (this.LabelDisabled(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                    value={this.SetValueField(item.field.id)}
                    type={item.field.id == 1009?"email":"text"}
                    onChange={this.handleChange} 
                    margin="normal"
                    variant="outlined"
                    className="InputInfoField"
                    classNamelabel="InputInfoFieldLabel"
                    required={item.required}
                    disabled={this.EnabledDisabledInputText(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}/>
                }else
                {
                Field = <InputPhoneNumber 
                    error={this.validateFieldPhoneNumber(this.SetValueField(item.field.id),item.required)}
                    id={item.field.id}
                    name={item.field.id}
                    required={item.required}
                    label={LabelField(item.field) +" "+ (this.LabelDisabled(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                    value={this.SetValueField(item.field.id)}
                    handleChange = {this.handleChangePhone}
                    margin="normal"
                    variant="outlined" 
                    className="InputInfoField"
                    classNamelabel="InputInfoFieldLabel"
                    disabled={this.EnabledDisabledInputText(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}
                ></InputPhoneNumber>
                }
            }
            break;
        case 1:
            {
                Field = <InputText 
                error={this.validateField(this.SetValueField(item.field.id),item.required)}
                id={item.field.id}
                name={item.field.id}
                label={LabelField(item.field) +" "+ (this.LabelDisabled(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                value={this.SetValueField(item.field.id)}
                margin="normal"
                type="number"
                variant="outlined"
                className="InputInfoField"
                classNamelabel="InputInfoFieldLabel"
                required={item.required}
                disabled={this.EnabledDisabledInputText(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}/>
            } 
            break;
        case 2:
            {
                Field = <ListItem role={undefined} dense>
                        <ListItemIcon>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                type="checkbox"
                                id={item.field.id}
                                name={item.field.id} 
                                checked={this.SetValueFieldCheck(item.field.id) == true ? true:false}
                                onChange = {this.handleChangeCheckbox}
                                required={item.required}
                                disabled={this.EnabledDisabledCheckbox(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}
                                color="primary"
                                ></Checkbox>
                            }
                            label={LabelField(item.field) +" "+ (this.LabelDisabledCheckbox(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                            />
                        </ListItemIcon>
                        </ListItem>
            } 
            break;
        case 3:
            {
                Field = 
                item.field.data &&
                <Select 
                    error={this.validateField(this.SetValueField(item.field.id),item.required)}
                    id={item.field.id}
                    name={item.field.id}
                    textLabel={LabelField(item.field) +" "+ (this.LabelDisabled(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                    data={item.field.data.values}  
                    value={this.SetValueField(item.field.id)}
                    className="defaultSelectValue"
                    classNamelabel="defaultSelectValueLabel"
                    variant="outlined" 
                    handleChangeSelect = {this.handleChangeSelect}
                    required={item.required}
                    disabled={this.EnabledDisabledInputText(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}
                ></Select>
                
            }
            break;
        case 5:
            {
                if(item.field.id == 1006)
                {
                Field = <DatePickerMinMax                  
                    error={this.validateFieldDateBirth(this.SetValueField(item.field.id),item.required,this.state.minYear,this.state.maxYear)}
                    id={item.field.id}
                    name={item.field.id}
                    value={this.SetValueField(item.field.id)}
                    label={LabelField(item.field) +" "+ (this.LabelDisabledDate(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                    className="InputInfoField"
                    handleChangeData={this.handleChangeData}
                    value={this.SetValueData(item.field.id)}
                    required={item.required}
                    disabled={this.EnabledDisabledDate(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}
                    min_age={this.state.minYear}
                    max_age={this.state.maxYear}
                ></DatePickerMinMax>
                }else
                {
                Field = <DatePicker                 
                    error={this.validateFieldDate(this.SetValueField(item.field.id),item.required)}
                    id={item.field.id}
                    name={item.field.id}
                    value={this.SetValueField(item.field.id)}
                    label={LabelField(item.field) +" "+ (this.LabelDisabledDate(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                    className="InputInfoField"
                    handleChangeData={this.handleChangeData}
                    value={this.SetValueData(item.field.id)}
                    required={item.required}
                    disabled={this.EnabledDisabledDate(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}
                ></DatePicker>
                }
            } 
            break;
        case 6:
            {
                Field = <InputTextComplete
                error={this.validateField(this.SetValueFieldCity(item.field.id),item.required)}
                id={item.field.id}
                name={item.field.id}
                label={LabelField(item.field) +" "+ (this.LabelDisabled(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id]))}
                value={this.SetValueFieldCity(item.field.id)}
                type={item.field.id == 1009?"email":"text"}
                onChange={this.handleChangeCity} 
                variant="outlined"
                className="InputInfoFieldCity"
                cities={cities}
                noOptionsText={localization.GetTranslate('Profile.NoSearchData')}
                disabled={this.EnabledDisabledInputText(item.alterableFromProfile,profile.data.res.clientInfo[item.field.id])}
                />
            } 
            break;
    }
    return Field;
}
    render() {
        var tr = {    
            Masterdata: localization.GetTranslate('Profile.Required data'),
            Additionaldata: localization.GetTranslate('Profile.Additional data'),
            Cancel: localization.GetTranslate('Profile.cancel'),
            Agree: localization.GetTranslate('Profile.agree'),
            yearsold: localization.GetTranslate('Profile.18 years old'),
            rules: localization.GetTranslate('Profile.I agree with the rules'),
            Save: localization.GetTranslate('buttons.Save'),
            Rule: localization.GetTranslate('Profile.Rule')
        }
        const {isLoaded, profile, rules, yearsold, progress, TabNotAvailable} = this.state;
        return(
            <div>
            {TabNotAvailable == true &&
            <div className="containers">
                <div className="TabNotAvailable">
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Label textLabel={localization.GetTranslate('Alert.TabNotAvailable')} className="CashbackLabelNotAvailable"></Label>   
                    </Grid>
                </Grid>
                </div>                
            </div>
            }
            {progress &&
            <div className="progress">
                <ColorLinearProgress />   
            </div>
            }  
            <div className="containers"> 
             <MessageWindow key={this.state.key} ></MessageWindow> 
            <form id="FormProfile" onSubmit={this.onSubmit}>    
            {!isLoaded &&
            TabNotAvailable == false &&
                <div class="preloader"></div>   
            }           
            {isLoaded &&
                    <ThemeProvider theme={materialThemeField}>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                                <Paper className="clientinfoBox">
                                <Label style={{color: themeColorText.color}} textLabel={tr.Masterdata} className="clientinfoLabel"></Label>  
                                <br></br>
                                {profile.data.preset.fields &&
                                profile.data.preset.fields.map(item =>
                                    (
                                        item.required === true ?
                                        this.TypeField(item,profile) : null
                                    ))
                                }                               
                                <br></br>       
                            </Paper>
                        </Grid>
                    </Grid>
                    </ThemeProvider>
                    }
                    {isLoaded &&
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <ThemeProvider theme={materialThemeField}>
                            {AppliedSettings.clientInfo_add_data &&
                            <Paper className="clientinfoBox">
                            <Label style={{color: themeColorText.color}} textLabel={tr.Additionaldata} className="clientinfoLabel"></Label>
                            <br></br>
                            {profile.data.preset.fields &&
                                profile.data.preset.fields.map(item =>
                                    (
                                        item.required === false ?
                                        this.TypeField(item,profile) : null
                                    ))
                                }  
                            </Paper>
                            }
                            </ThemeProvider>
                            {AppliedSettings.clientInfo_change_info == false &&
                            
                            <Paper className="clientinfoBox Save">
                                {profile.data.agreeLicense &&
                                <div>
                                        <ThemeProvider theme={ThemeCheckbox}>
                                        <Checkbox 
                                            className="checkboxRules"
                                            checked={yearsold} 
                                            label={tr.yearsold}
                                            ChangeCheckbox={this.ChangeCheckBoxYearsOld}
                                            required={true}
                                        >
                                        </Checkbox>
                                        <Checkbox
                                            className="checkboxRules"
                                            key={this.state.key}
                                            checked={rules} 
                                            label={tr.rules}
                                            ChangeCheckbox={this.ChangeCheckBoxRules}
                                            required={true}
                                        ></Checkbox>
                                        </ThemeProvider>
                                        {AppliedSettings.clientInfo_profile_rule === 0 &&
                                        <Link  
                                            className="link"
                                            variant="body2"
                                            style={
                                                {
                                                    cursor: "pointer",
                                                    fontSize: "1rem",
                                                    marginLeft: -10,
                                                    color: themeColorLink.color
                                                }
                                            }
                                            color="primary" 
                                            onClick={this.handleClickOpen}>
                                                {localization.GetTranslate('Profile.rules')}
                                        </Link>
                                        }
                                        {AppliedSettings.clientInfo_profile_rule === 1 &&
                                        <Link target="_blank" rel="noopener" href={localization.GetTranslate('Profile.text_rule')}  
                                            className="link"
                                            variant="body2"
                                            style={
                                                {
                                                    cursor: "pointer",
                                                    fontSize: "1rem",
                                                    marginLeft: -10,
                                                    color: themeColorLink.color
                                                }
                                            }
                                            color="primary" >
                                                {localization.GetTranslate('Profile.rules')}
                                        </Link>
                                        }
                                        <Dialog
                                        open={this.state.open}
                                        onClose={this.handleClose}
                                        scroll={'paper'}
                                        aria-labelledby="scroll-dialog-title"
                                        aria-describedby="scroll-dialog-description"
                                        
                                        >
                                        <DialogTitle style={{padding:'0px 24px'}} className="DialogTitle" id="scroll-dialog-title">{tr.Rule}</DialogTitle>
                                        <DialogContent className="DialogContent" dividers={'paper'}>
                                            <DialogContentText
                                            id="scroll-dialog-description"
                                            className="DialogContentText"
                                            tabIndex={-1}
                                            >
                                            {localization.GetTranslate('Profile.text_rule')
                                            }
                                            </DialogContentText>
                                        </DialogContent>
                                        <DialogActions className="DialogActions">
                                            <ButtonRule onClick={this.handleCancel} style={{color: themeColorLink.color == "primary"?"#3f51b5":themeColorLink.color}}>
                                            {tr.Cancel}
                                            </ButtonRule>
                                            <ButtonRule onClick={this.handleAgree} style={{color: themeColorLink.color == "primary"?"#3f51b5":themeColorLink.color}}>
                                            {tr.Agree}
                                            </ButtonRule>
                                        </DialogActions>
                                        </Dialog>
                                </div>
                                }
                                <Dialog open={this.state.openActivate} onClose={this.handleCloseActivate} aria-labelledby="form-dialog-title" disableBackdropClick={true}>
                                            <DialogTitle id="form-dialog-title">{localization.GetTranslate('Profile.activate_code')}</DialogTitle>
                                            <DialogContent>
                                            <TextField
                                                autoFocus
                                                onChange={this.onChangeActivate}
                                                value={this.state.FieldActivate}
                                                margin="dense"
                                                id="name"
                                                name="textField"
                                                label={localization.GetTranslate('Profile.Code')}
                                                type="text"
                                                fullWidth
                                            />
                                            </DialogContent>
                                            <DialogActions>
                                            <Button 
                                            onClick={this.handleCloseActivate} color="primary"
                                            style={{marginLeft: 10,marginBottom: 10}}
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            value="submit"
                                            textLabel={localization.GetTranslate('Profile.cancel')}
                                            className="DialogButtonsActivate"
                                            >
                                            </Button>
                                            <Button 
                                            onClick={this.resendActivationCode}
                                            style={{marginBottom: 10}}
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            value="submit"
                                            textLabel={localization.GetTranslate('Profile.resend code')}
                                            className="DialogButtonsActivate"
                                            >
                                            </Button>
                                            <Button 
                                            onClick={this.onSubsmitActivate}
                                            style={{marginBottom: 10,marginRight: 10}}
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            value="submit"
                                            textLabel={localization.GetTranslate('Profile.activate')}
                                            className="DialogButtonsActivate"
                                            >
                                            </Button>
                                            
                                            </DialogActions>
                                        </Dialog>
                                    <Button
                                            disabled={this.agreeLicense(profile.data.agreeLicense) | this.state.asyncDisabled}
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            value="submit"
                                            textLabel={tr.Save}
                                            className="SaveButton_profile"
                                        >
                                    </Button>  
                            </Paper>
                            }
                        </Grid>
                    </Grid>
            }                
            </form>
            </div>
            </div>
        );

    }
}
export default ClientInfo;

